/* 业务定义常量 */
const DataConstant = {
    system: {
        success: 1,
        fail: 0,
        yes: 1,
        no: 0,
        valid: 1,
        invalid: 0
    },
    // 商品
    goods: {
        putaway_: [{'name_': '全部', 'id_': '-1'}, {'name_': '上架', 'id_': '1'}, {'name_': '已下架', 'id_': '0'}]
    },
    // 客户
    client: {
        loginStatus: {0: '已禁用', 1: '已启用', 2: '已停用'},
        loginStatusList: [{'name_': '已禁用', 'id_': 0}, {'name_': '已启用', 'id_': 1}, {'name_': '已停用', 'id_': 2}],
        from: {1: '客户注册', 2: '新增导入'}
    },
    // 销售单
    saleOrder: {
        formStatusGroups: [
            {'name_': '待提交', 'id_': '11'},
            {'name_': '待订单审核', 'id_': '21'},
            {'name_': '待财务审核', 'id_': '31'},
            {'name_': '待出库', 'id_': '41-51'},
            {'name_': '待发货', 'id_': '61-71'},
            {'name_': '待收货', 'id_': '81-91'},
            {'name_': '已完成', 'id_': '100'},
            {'name_': '已作废', 'id_': '999'}
        ],
        formStatus: {
            11: 'DaiTiJiao', 21: 'DDDSH', 31: 'DCWSH', 41: 'DaiChuKu', 51: 'DCK_BF_',
            61: 'DaiFaHuo', 71: 'DFH_BF_', 81: 'DaiShouHuo', 91: 'DSH_BF_', 100: 'YiWanCheng', 999: 'YiZuoFei'
        },
        /*formStatus: {
            11: '待提交', 21: '待订单审核', 31: '待财务审核', 41: '待出库', 51: '待出库（部分）',
            61: '待发货', 71: '待发货(部分)', 81: '待收货', 91: '待收货（部分）', 100: '已完成', 999: '已作废'
        },*/
        financeStatusFilter: [
            {id_: "1-51", name_: '待收款'},
            {id_: "100", name_: '已完成'},
            {id_: "999", name_: '已作废'},
        ],
        financeStatus: {1: 'DaiShouKuan', 50: 'DSK_BF_', 100: 'YiWanCheng', 999: 'YiZuoFei'},
        // financeStatus: {1: '待收款', 50: '待收款（部分）', 100: '已完成', 999: '已作废'},
        backStatus: {1: '无退货申请', 50: '退货待审核', 100: '退货处理中', 999: '退货已完成'},
        shipWay: {0: 'KuaiDi', 1: 'SongHuoShangMen', 2: 'ShangMenZiQu', 3: 'WuLiuHuoYun', 4: 'QiTa'},
        // shipWay: {0: '快递', 1: '送货上门', 2: '上门自取', 3: '物流货运', 4: '其他'},
        option: {
            1: '创建订单',
            2: '编辑订单',
            3: '提交订单',
            4: '订单审核',
            5: '财务审核',
            6: '驳回',
            7: '添加收款',
            8: '在线支付',
            9: '添加收款',
            10: '收款审核',
            11: '收款作废',
            12: '收款作废',
            13: '出库',
            14: '出库审核',
            15: '发货',
            16: '添加物流',
            17: '修改物流',
            18: '出库作废',
            19: '收货',
            20: '订单核准',
            21: '取消订单',
            22: '创建退货单',
            23: '打印订货单',
            24: '打印发货单',
            25: '导出订货单',
            26: '导出发货单为Excel/PDF文件',
            27: '订单核准',
            28: '编辑收货信息',
            29: '打印电子面单',
            30: '电子面单发货',
            31: '新增订货单明细',
            32: '删除订货单明细',
            33: '修改订货单明细',
            34: '支付方式',
            35: '打印订货单(蓝牙打印)',
            88: '添加备注说明',
            100: '订单完成',
            101: '强制完成',
            999: '订单作废'
        }
    },
    // 销售退货
    saleBack: {
        formStatus: {
            11: '待提交',
            21: '待退货审核',
            31: '待财务审核',
            41: '待入库',
            51: '待入库（部分）',
            61: '待付款',
            71: '待付款(部分)',
            100: '已完成',
            999: '已作废'
        },
        formStatusFilter: [
            {'name_': '待提交', 'id_': '11'},
            {'name_': '待退货审核', 'id_': '21'},
            {'name_': '待财务审核', 'id_': '31'},
            {'name_': '待入库', 'id_': '41-51'},
            {'name_': '待付款', 'id_': '61-71'},
            {'name_': '已完成', 'id_': '100'},
            {'name_': '已作废', 'id_': '999'}
        ],
        financeStatus: {1: '待付款', 50: '待付款（部分）', 100: '已完成', 999: '已作废'},
        financeStatusFilter: [{'name_': '待付款', 'id_': '1,50'}, {'name_': '已完成', 'id_': '100'}, {
            'name_': '已作废',
            'id_': '999'
        }],
        option: {
            1: '创建退单',
            2: '编辑退单',
            3: '提交退单',
            4: '退货审核',
            5: '财务审核',
            6: '入库',
            7: '入库审核',
            8: '入库作废',
            9: '添加付款',
            10: '付款作废',
            11: '添加付款',
            12: '付款审核',
            13: '付款作废',
            14: '打印',
            15: '导出',
            16: '打印',
            17: '导出',
            100: '退单完成',
            999: '退单作废'
        }
    },
    // 出库单
    outHouse: {
        formStatus: {11: 'DaiTiJiao', 21: 'DaiShenHe', 31: 'DaiFaHuo', 41: 'DaiShouHuo', 100: 'YiWanCheng', 999: 'YiZuoFei'},
        // formStatus: {11: '待提交', 21: '待审核', 31: '待发货', 41: '待收货', 100: '已完成', 999: '已作废'},
        type: {1: '其他出库', 2: '销售出库', 4: '盘亏出库', 5: '调拨出库', 6: '采购退货'},
    },
    // 入库单
    inHouse: {
        formStatus: {11: '待提交', 21: '待审核', 100: '已完成', 999: '已作废'},
        type: {1: '其他入库', 2: '采购入库', 3: '退货入库', 4: '盘盈入库', 5: '调拨入库'},
    },
    // 调拨
    transferHouse: {
        formStatus: {11: '待出库', 51: '待入库', 100: '已完成', 999: '已作废'},
    },
    // 调拨
    houseCheck: {
        formStatus: {11: '待提交', 21: '待审核', 100: '已完成', 999: '已作废'},
    },
    // 采购
    purchaseOrder: {
        financeStatus: {1: '待付款', 50: '待付款（部分）', 100: '已完成', 999: '已作废'},
        formStatus: {11: '待提交', 41: '待入库', 51: '待入库（部分）', 100: '已完成', 999: '已作废'},
        backStatus: {0: '无退货申请', /*YSDH-4385: 1: '退货待审核',*/ 50: '退货处理中', 100: '退货已完成'},
        formStatusFilter: [{'name_': '待提交', 'id_': '11'}, {'name_': '待入库', 'id_': '41-51'}, {
            'name_': '已完成',
            'id_': '100'
        }, {'name_': '已作废', 'id_': '999'}],
        financeStatusFilter: [{'name_': '待付款', 'id_': '1,50'}, {'name_': '已完成', 'id_': '100'}, {
            'name_': '已作废',
            'id_': '999'
        }],
        option: {
            1: '创建采购单', 2: '编辑采购单', 3: '提交采购单', 4: '入库', 5: '入库作废', 6: '添加付款', 7: '付款审核', 8: '打印', 9: '打印',
            10: '导出', 11: '导出', 12: '付款作废', 100: '采购单完成', 999: '采购单作废'
        }
    },
    // 采购退货
    purchaseBack: {
        formStatus: {11: '待提交', /* 前台不可见: 21: '待审核', 31: '待财务审核',*/ 41: '待出库', 51: '待出库（部分）', 100: '已完成', 999: '已作废'},
        financeStatus: {1: '待收款', 50: '待收款（部分）', 100: '已收款', 999: '已作废'},
        option: {
            1: '创建退单', 2: '创建退单', 3: '提交退单', 4: '编辑退单', 5: '出库', 6: '出库作废', 7: '添加收款', 8: '收款审核',
            100: '采购退货完成', 999: '采购退货作废', 9: '退货单打印', 10: '退货单导出', 11: '出库单打印', 12: '出库单导出', 13: '收款作废'
        }
    },
    // 收款
    income: {
        formStatus: {11: '待提交', 51: '待审核', 100: '已完成', 999: '已作废'},
        allotStatus: {11: '待核销', 51: '待核销', 100: '已核销', 999: '已作废'},
        payType: {1: 'XianXiaZhiFu', 2: 'WeiXinZhiFu', 3: 'ZFBZF', 4: 'YuEZhiFu'},
        // payType: {1: '线下支付', 2: '微信', 3: '支付宝', 4: '预存款'},
    },
    //付款单
    pay: {
        formStatus: {11: 'DaiTiJiao', 51: 'DaiShenHe', 100: 'YiWanCheng', 999: 'YiZuoFei'},
        // formStatus: {11: '待提交', 51: '待审核', 100: '已完成', 999: '已作废'},
    },
    //交班结算
    wordReport: {
        formStatus: {11: '待提交', 51: '待审核', 100: '已完成', 999: '已作废'},
    },
    // 账号
    account: {
        type: {1: '管理端账号', 2: '管理端账号', 3: '订货端账号'},
        shopRegister: {11: '待审核', 100: '审核通过', 999: '审核不通过'},
        login_status_: {
            0: '已禁用',
            1: '已启用',
            2: '已停用',
        }
    },
    //发票类型
    taxType: {
        0: '无需发票',
        1: '增值税普通发票',
        2: '增值税专用发票',
        3: '其他发票'
    },
    //下单方式
    orderFormFilter: [
        {id_: 1, name_: "代客下单"},
        {id_: '2-3', name_: "自主下单"}
    ],
    // 登陆源
    loginFrom: {
        'PC': 'PC商城',
        'APP': 'APP商城',
        'TV': 'TV商城',
        'WXAPP': '微信商城',
        'WEBAPP': '手机商城',
    },
    saleCommissions: {
        calModel: {1: '按订单销售毛利提成', 2: '按订单销售收入提成'},
        calBelong: {1: '按客户所属员工', 2: '按制单人'},
        calBack: {1: '按退货金额比例扣除提成金额', 2: '订单有退货不进行提成'},
        formStatus: {11: '待审核', 21: '待打款', 100: '已完成', 999: '驳回',},
    },
    goodsPromotion: {
        type: {1: 'MaiZeng', 2: 'ZhiJiang', 3: 'DaZhe', 4: 'YuShou'}
        //type: {1: '买赠', 2: '直降', 3: '打折', 4: '预售'}
    },
    orderPromotion: {
        type: {1: 'DingDanManZeng', 2: 'DingDanManJian', 3: 'DingDanManZhe'}
        //type: {1: '订单满赠', 2: '订单直降', 3: '订单打折'}

    },
    goodsPackage: {
        goodsPackageStatus: {11: '未开始', 100: '进行中', 999: '已过期'}
    },
    // 商机
    businessOpportunities: {
        from: {1: '注册', 2: '新增', 3: '导入'},
        formStatus: {11: '未分配', 21: '待跟进', 31: '跟进中', 100: '合作客户', 999: '无效'}
    },
    payType: {
        1: 'XianXiaZhiFu',
        2: 'WeiXinZhiFu',
        3: 'ZFBZF',
        4: 'YuEZhiFu',
        5: 'HuoDaoFuKuan',
        6: 'FanKuanZhiFu',
        7: 'YiShengZhiFu',
        8: 'ZaiXianZhiFu',
        9: 'MercadoPagoZhiFu',
        10: 'ZhiNengDaoZhangShiBie',
        11: 'YinLianZhiFu',
    },
    // payType: {1: '线下支付', 2: '微信', 3: '支付宝', 4: '预存款', 5: '货到付款'},

    /*以下针对订货端新增*/
    goodsPromotionType: {1: '买赠', 2: '直降', 3: '打折', 4: '预售',},
    clientOutHouse: {11: '待发货', 21: '待发货', 31: '待发货', 41: '待收货', 100: '已完成', 999: '已取消'},
    refundStatus: {11: 'DaiShenHe', 21: 'DaiShenHe', 31: 'DaiShenHe', 41: 'DaiTuiHuo', 51: 'DaiTuiHuo', 61: 'DaiTuiKuan', 71: 'DaiTuiKuan', 100: 'YiWanCheng', 999: 'YiQuXiao',},
    // refundStatus: {11: '待审核', 21: '待审核', 31: '待审核', 41: '待退货', 51: '待退货', 61: '待退款', 71: '待退款', 100: '已完成', 999: '已取消',},
    refundFinanceStatus: {1: '待退款', 50: '待退款', 100: '已完成', 999: '已作废'},
    inquiry: {
        formStatus: {11: '报价中', 21: '已报价', 100: '已下单', 999: '已关闭'},
        buyingFormStatus: {11: '待处理', 21: '处理中', 100: '已完成', 999: '已关闭'}
    },
    orderStatus: {
        11: "DaiQueRen",
        21: "DaiQueRen",
        31: "DaiQueRen",

        41: "DaiFaHuo",
        51: "DaiFaHuo",
        61: "DaiFaHuo",
        71: "DaiFaHuo",

        81: "DaiShouHuo",
        91: "DSH_BF_",
        100: "YiWanCheng",
        999: "YiQuXiao",
    },
    couponType: {
        1: 'XinRenQuan',
        2: 'ManJianQuan',
        3: 'ShangPinQuan',
    },
};

export default DataConstant;
